module.exports =
  '_DASHBOARD':
    'TITLE': 'Dashboard'
    'HISTORY':
      'TOTAL_ROUNDS': 'Total Rounds'
      'BEST_SCORE': 'Best Score'
      'AVERAGE_SCORE': 'Average Score'
      'SCORE': 'Score'
      'FAIRWAY_HIT': 'Fairway hit'
      'GIR': 'GIR (%)'
      'BOGEY_ON': 'GIR+1 (%)'
    'PERIOD_FILTER':
      'TARGET_RANGE': 'Period'
      'TARGET_ROUND': 'Target round'
      'INCLUDE_1_5': 'Include 1.5 Round'
      'EXCLUDE_1_5': 'Exclude 1.5 Round'
      'INCLUDE_0_5': 'Include 0.5 Round'
      'EXCLUDE_0_5': 'Exclude 0.5 Round'
      'INCLUDE_1_5_SP': 'Include 1.5R'
      'EXCLUDE_1_5_SP': 'Exclude 1.5R'
      'INCLUDE_0_5_SP': 'Include 0.5R'
      'EXCLUDE_0_5_SP': 'Exclude 0.5R'
    'BEST_SCORE': "Best Score"
    'FAVORITE_COURSE': "Favorite Course"
    'FAIRWAY_KEEP_COURSE': "FW Keep Course"
    'RANKING': "Ranking"
    'MESSAGES':
      'M0001': 'This operation is not permitted for current signed in user. Please sign out and try again.'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/i18n/en.coffee